import { RetailerSummary } from "api/admin";
import DSAutocomplete from "views/system-design/DSAutocomplete";
import DSTextField from "views/system-design/DSTextField";

type Props = {
  retailers: RetailerSummary[];
  isLoading: boolean;
  /** The selected retailer id (kept in the page URL). */
  value?: string;
  onChange: (id: string | undefined) => void;
};

/** Picks a retailer by name; typing filters the list, without regard to case. */
const RetailerSelect = ({ retailers, isLoading, value, onChange }: Props) => {
  const selected = retailers.find((retailer) => retailer.id === value) ?? null;

  return (
    <DSAutocomplete<RetailerSummary>
      size="small"
      options={retailers}
      loading={isLoading}
      value={selected}
      getOptionLabel={(retailer) => retailer.name}
      isOptionEqualToValue={(option, current) => option.id === current.id}
      onChange={(_event, retailer) => onChange(retailer?.id)}
      noOptionsText="No retailers"
      sx={{ maxWidth: 360 }}
      renderInput={(params) => (
        <DSTextField
          {...params}
          label="Retailer"
          placeholder="Pick a retailer"
        />
      )}
    />
  );
};

export default RetailerSelect;
